import { Box, CircularProgress } from '@mui/material';

const Loading = () => {
    return (
        <Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box>
    );
};

export default Loading;
